import React from "react";
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from '../img/logo.svg';
import "./componentcss/Navbar.css";
import Form from 'react-bootstrap/Form';
import Profile from '../img/profile.svg';
import PardetailB from '../img/pardetailB.png';
import Camera from '../img/cameraOn.png';
import TurnOff from '../img/turnOff.png';
import { useLogin } from '../component/LoginContext';
import { useNavigate } from 'react-router-dom';
function Navbarweb() {
    const { user, pwd , isLoggedIn } = useLogin();
    const navigate = useNavigate();
    const { logout } = useLogin();
    
    const handleLogout = () => {
        logout();  
        navigate('/');
    };

    return (
            <Navbar className="bgnav justify-content-between">
                <Form >
                    <Navbar.Brand >
                        <img
                        src={Logo}
                        className="ms-3 d-inline-block align-top logo"
                        alt="medlogo"
                        />
                        <span className="ms-3 logotext">MOBILE BUS TELE MEDICINE</span>
                    </Navbar.Brand>
                    
                </Form >
                {/* เช็คว่าผู้ใช้ได้ทำการ Login แล้วหรือยัง */}
                {isLoggedIn ?
                    <Form className="d-flex justify-content-end">
                        <NavDropdown
                            title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                src={Profile}
                                style={{ width: 'auto', height: 'auto', maxHeight: '40px', maxWidth: '40px', borderRadius: '50%',marginRight:'10px' }}
                                alt="profile"
                                />
                            </div>
                            }
                            id="profiledropdown"
                            className="custom-dropdown"
                            align="end"  // ทำให้ dropdown menu ชิดขวาตามตัว dropdown
                        >
                            <div className="dropitem">
                                <div className="d-flex align-items-center mb-3">
                                    <img
                                        src={Profile}
                                        className="d-inline-block align-top dropprofile"
                                        style={{ 
                                            width: 'auto', 
                                            height: 'auto', 
                                            maxHeight: '30px', 
                                            maxWidth: '30px', 
                                            borderRadius: '50%',
                                            marginLeft: '10px' 
                                        }} 
                                        alt="medlogo" 
                                    />

                                    <span className="ms-3">{user?.name ? user?.name : 'Please Login'}</span>
                                </div>
                                
                                <>
                                    <hr/>
                                    <NavDropdown.Item><img src={PardetailB} className="imgDropItem ms-2 me-3"/>Arrival Worklist</NavDropdown.Item>
                                    <NavDropdown.Item><img src={Camera} className="imgDropItem ms-2 me-3"/>Tele Medicine</NavDropdown.Item>
                                    <hr/>
                                </>
                                
                                <NavDropdown.Item onClick={handleLogout}><img src={TurnOff} className="imgDropItem ms-2 me-3"/>Sign out</NavDropdown.Item>
                            </div>
                            
                        </NavDropdown>
                    </Form> 
                : 
                    <a href="/" className="loginbutton"><h4>Login</h4></a>
                }
                
                
            </Navbar> 
    );
}

export default Navbarweb;